<template>
  <MainPage class="panel-container pgap">
    <slot></slot>
  </MainPage>
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
    };
  },
  computed:{
  },
  mounted(){
  },
  methods:{
  }
};
</script>
<style lang="less" scoped>
.panel-container{
}
</style>
